module.exports = __webpack_public_path__ + "img/member09.714065af.png";